export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7061e6af857fd078e55cfd9d74ecb9c379047cc14a&name=pushAdClickData!'